// Content component

import React from "react";
import { connect } from "react-redux";

import NavigationButtons from "./NavigationButton";

import ContentHeader from "@common/components/ContentHeader";
import RisksLayout from "./Risks";
import CompletionDialog from "@common/components/CompletionDialog";
import generatePdf from "@common/pdf";
import { ContentWrapper, ContentLayout } from "@common/styled/content";
import { toggleBackgroundScroll } from "@common/utilities";

class Content extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCompletionDialogShown: false,
      isAppendixDialogShown: false
    };
  }

  /**
   * Toggle the appendix dialog
   * @param  {boolean} isShown Whether appendix dialog is shown
   */
  toggleAppendixDialog = isShown => {
    toggleBackgroundScroll(isShown);

    this.setState({
      isAppendixDialogShown: isShown
    });
  };

  /**
   * Toggle the assessment completion dialog
   * @param  {boolean} isShown Whether assessment completion dialog is shown
   */
  toggleCompletionDialog = isShown => {
    toggleBackgroundScroll(isShown);

    this.setState({
      isCompletionDialogShown: isShown
    });
  };

  render() {
    const { section, stepsMeta } = this.props;
    const { activeSubStep } = stepsMeta;

    // Store whether a risk has been indicated in the section (for displaying Appendix dialog)
    const isRiskIndicated = section.subsections[activeSubStep].risks.some(
      risk => risk.isRisk
    );

    return (
      <ContentWrapper>
        <CompletionDialog
          isShown={this.state.isCompletionDialogShown}
          title={section.title}
          pdfLinks={section.pdfLinks}
          onPdfClick={action =>
            generatePdf(section, action, "Pretravel Assessment")}
        />
        <ContentHeader>
          {section.subsections[activeSubStep].subTitle}
        </ContentHeader>
        <ContentLayout marginT={3} boxShadow>
          <RisksLayout
            section={section}
            activeSubStep={activeSubStep}
            isAppendixDialogShown={this.state.isAppendixDialogShown}
            hideAppendixDialog={() => this.toggleAppendixDialog(false)}
          />
          <NavigationButtons
            isRiskIndicated={isRiskIndicated}
            showAppendixDialog={() => this.toggleAppendixDialog(true)}
            showCompletionDialog={() => this.toggleCompletionDialog(true)}
          />
        </ContentLayout>
      </ContentWrapper>
    );
  }
}

function mapStateToProps(store) {
  return {
    stepsMeta: store.preTravel.sidebar.stepsMeta,
    section: store.preTravel.app
  };
}

export default connect(mapStateToProps, null)(Content);



// WEBPACK FOOTER //
// ./src/pretravel/components/Content/content.jsx